import axios from "axios";
import { defaultUrl } from "../features/actions";
import { getHeader } from "../utilities/importantFns";
import {
  makeDeleteRequest,
  makePostRequest,
  makePutRequest,
} from "../utilities/common";
//https://api.pendulumafrica.com/reports/subjects
//   const fetchDashboardData = async () => {
//     const data = await axios.get(`${defaultUrl}/user/dashboard`, getHeader());
//     // console.log({ d: data.data.data });
//     setSummaryData(data?.data?.data);
//   };

export async function getSubjects() {
  const response = await axios.get(
    `${defaultUrl}/reports/subjects`,
    getHeader()
  );

  return response.data;
}
export async function getAllSubjectForClasses() {
  const response = await axios.get(
    `${defaultUrl}/classroom?include=subjects
`,
    getHeader()
  );

  return response.data;
}

export async function createSubject(payload: {
  name: string;
  code: string;
  description: string;
}) {
  const response = await makePostRequest(
    `${defaultUrl}/reports/subjects`,
    payload
  );

  return response;
}
export async function updateSubject({
  payload,
  subjectId,
}: {
  payload: {
    name: string;
    code: string;
    description: string;
  };
  subjectId: string;
}) {
  const response = await makePutRequest(
    `${defaultUrl}/reports/subjects/${subjectId}`,
    payload
  );

  return response;
}

export async function deleteSubject({ subjectId }: { subjectId: string }) {
  const response = await makeDeleteRequest(
    `${defaultUrl}/reports/subjects/${subjectId}`
  );

  return response;
}

//classrooms
export async function getClassrooms() {
  const response = await axios.get(`${defaultUrl}/classroom?include=subjects`, getHeader());

  return response.data;
}

export async function editClassroom({
  classroomId,
  name,
  assessment_mode,
}: {
  classroomId: string;
  name: string;
  assessment_mode?: string;
}) {
  const payload: any = { name };
  if (assessment_mode) {
    const mode =
      assessment_mode === "traits_only" ? "traits_only" : "standard_matrix";
    payload.assessment_mode = mode;
  }

  const response = await makePutRequest(
    `${defaultUrl}/classroom/${classroomId}`,
    payload
  );

  return response;
}
export async function assignSubjectToClass({
  subject_ids,
  classroomId,
}: {
  subject_ids: string[];
  classroomId: string;
}) {
  const response = await makePostRequest(
    `${defaultUrl}/reports/students/assign-subjects/${classroomId}`,
    { subject_ids }
  );

  return response;
}
export async function unassignSubjectToClass({
  subject_ids,
  classroomId,
}: {
  subject_ids: string[];
  classroomId: string;
}) {
  const response = await makePostRequest(
    `${defaultUrl}/reports/students/unassign-subjects/${classroomId}`,
    { subject_ids }
  );

  return response;
}
export async function getGradingSystem() {
  const response = await axios.get(
    `${defaultUrl}/school/grading-config`,
    getHeader()
  );

  return response.data;
}
////edit grading system

export async function updateGradingSystem({ payload }: { payload: any }) {
  const response = await makePutRequest(
    `${defaultUrl}/school/edit/grading-config`,
    payload
  );

  return response;
}

export async function getStudentReport(
  studentId: string,
  term?: string | number,
  session?: string,
) {
  const payload: any = {};
  if (term !== undefined && term !== null && term !== "") {
    payload.term = Number(term);
  }
  if (session) {
    payload.academic_session = session;
  }
  const response = await axios.get<any>(
    `${defaultUrl}/students-report-info/${studentId}`,
    { params: payload, ...getHeader() }
  );

  return response;
}

//set grades
export async function setGradeForStudent({ payload }: { payload: any }) {
  const response = await makePostRequest(
    `${defaultUrl}/reports/grades/student-multi-subjects`,
    payload
  );

  return response;
}

// Save trait-only / developmental evaluation with endpoint fallback
export async function saveTraitEvaluation({ payload }: { payload: any }) {
  const token = sessionStorage.getItem("token")?.replace(/['"]+/g, "");
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
    Accept: "application/json",
  };

  try {
    // Attempt dedicated trait endpoint
    const res = await axios.post(
      `${defaultUrl}/reports/traits-evaluation`,
      payload,
      { headers }
    );
    return res.data;
  } catch (err: any) {
    // If new endpoint isn't live yet (404 / 405), fallback to existing endpoint with empty subjects
    return await makePostRequest(
      `${defaultUrl}/reports/grades/student-multi-subjects`,
      {
        ...payload,
        subjects: payload.subjects || [],
      },
      "Trait evaluation recorded successfully!"
    );
  }
}

export async function updateStudentReport({
  payload,
  studentId,
}: {
  payload: any;
  studentId: string;
}) {
  const response = await makePutRequest(
    `${defaultUrl}/students-report-info/${studentId}`,
    payload
  );

  return response;
}

// Bank Accounts
export interface BankAccountItem {
  id?: number | string;
  account_name: string;
  account_number: string;
  bank_name: string;
}

export async function getBankAccounts() {
  const response = await axios.get(
    `${defaultUrl}/bank_accounts`,
    getHeader()
  );
  return response.data;
}

export async function createBankAccount(payload: {
  accounts: BankAccountItem[];
}) {
  const response = await makePostRequest(
    `${defaultUrl}/bank_accounts`,
    payload
  );
  return response;
}

export async function updateBankAccount(payload: {
  accounts: BankAccountItem;
}) {
  const response = await makePutRequest(
    `${defaultUrl}/bank_accounts`,
    payload
  );
  return response;
}

export async function deleteBankAccount({ id }: { id: string | number }) {
  const response = await makeDeleteRequest(
    `${defaultUrl}/bank_accounts/${id}`
  );
  return response;
}

/* ==========================================
   STATIONERY & INVOICE MANAGEMENT API SERVICES
   ========================================== */

export interface StationeryItem {
  id: string;
  name: string;
  description: string;
  unit_price: number;
  is_active?: boolean;
  created_at?: string;
  updated_at?: string;
}

export interface CreateStationeryPayload {
  name: string;
  description: string;
  unit_price: number;
  is_active?: boolean;
}

export interface UpdateStationeryPayload {
  name: string;
  description: string;
  unit_price: number;
  is_active?: boolean;
}

export async function getStationeries(params?: {
  search?: string;
  page?: number;
  per_page?: number;
}) {
  const queryParams = new URLSearchParams();
  if (params?.search) queryParams.append("q", params.search);
  if (params?.page) queryParams.append("page", String(params.page));
  if (params?.per_page) queryParams.append("per_page", String(params.per_page));

  const query = queryParams.toString() ? `?${queryParams.toString()}` : "";
  const response = await axios.get(`${defaultUrl}/stationaries${query}`, getHeader());
  return response.data;
}

export async function getStationeryById(id: string) {
  const response = await axios.get(`${defaultUrl}/stationaries/${id}`, getHeader());
  return response.data;
}

export async function createStationery(payload: CreateStationeryPayload) {
  const response = await makePostRequest(`${defaultUrl}/stationaries`, payload);
  return response;
}

export async function updateStationery({
  id,
  payload,
}: {
  id: string;
  payload: UpdateStationeryPayload;
}) {
  const response = await makePutRequest(`${defaultUrl}/stationaries/${id}`, payload);
  return response;
}

export async function deleteStationery(id: string) {
  const response = await makeDeleteRequest(`${defaultUrl}/stationaries/${id}`);
  return response;
}

export interface InvoiceLineItem {
  id?: string;
  description?: string;
  quantity: number;
  unit_price: number;
  discount_percentage?: number;
  discount_amount?: number;
  gross_amount?: number;
  net_amount?: number;
  amount?: number;
  notes?: string | null;
  stationary_id?: string;
  stationary?: StationeryItem;
}

export interface InvoiceLineItemPayload {
  description: string;
  quantity: number;
  unit_price: number;
  discount_percentage?: number;
}

export interface InvoicePayload {
  student_id: string;
  academic_session: string;
  term: string;
  total_amount: number;
  due_date: string;
  notes?: string;
  line_items: InvoiceLineItemPayload[];
}

export interface InvoiceItem {
  id: string;
  invoice_code?: string;
  student_id: string;
  student?: {
    id: string;
    name: string;
    email?: string | null;
  };
  school_name?: string;
  school_signature?: string;
  academic_session: string;
  term: string | number;
  gross_subtotal?: number;
  overall_discount_percentage?: number;
  overall_discount_amount?: number;
  total_discount_amount?: number;
  total_amount: number;
  amount_paid?: number;
  remaining_balance?: number;
  status?: "issued" | "partially_paid" | "paid" | string;
  due_date: string;
  line_items?: InvoiceLineItem[];
  stationary_items?: {
    id?: string;
    stationary_id?: string;
    quantity: number;
    unit_price?: number;
    discount_percentage?: number;
    discount_amount?: number;
    gross_amount?: number;
    net_amount?: number;
    amount?: number;
    stationary?: StationeryItem;
  }[];
  notes?: string;
  created_at?: string;
  updated_at?: string;
}

export async function createInvoice(payload: InvoicePayload) {
  const response = await makePostRequest(`${defaultUrl}/invoices`, payload);
  return response;
}

export async function updateInvoice({
  id,
  payload,
}: {
  id: string;
  payload: InvoicePayload;
}) {
  const response = await makePutRequest(`${defaultUrl}/invoices/${id}`, payload);
  return response;
}

export async function deleteInvoice(id: string) {
  const response = await makeDeleteRequest(`${defaultUrl}/invoices/${id}`);
  return response;
}

export async function getStudentInvoices({
  student_id,
  academic_session,
  term,
}: {
  student_id: string;
  academic_session?: string;
  term?: string;
}) {
  const params = new URLSearchParams();
  if (academic_session) params.append("academic_session", academic_session);
  if (term) params.append("term", term);

  const query = params.toString() ? `?${params.toString()}` : "";
  const response = await axios.get(
    `${defaultUrl}/invoices/student/${student_id}${query}`,
    getHeader()
  );
  return response.data;
}

export async function getAllInvoices(filters?: {
  academic_session?: string;
  term?: string;
  q?: string;
  search?: string;
  page?: number;
  per_page?: number;
}) {
  const params = new URLSearchParams();
  if (filters?.academic_session)
    params.append("academic_session", filters.academic_session);
  if (filters?.term) params.append("term", filters.term);
  if (filters?.q || filters?.search)
    params.append("q", (filters.q || filters.search)!);
  if (filters?.page) params.append("page", String(filters.page));
  if (filters?.per_page) params.append("per_page", String(filters.per_page));

  const query = params.toString() ? `?${params.toString()}` : "";
  const response = await axios.get(
    `${defaultUrl}/invoices${query}`,
    getHeader()
  );
  return response.data;
}

export async function getInvoiceByCodeOrId(codeOrId: string) {
  const cleanId = encodeURIComponent(codeOrId.trim());
  const response = await axios.get(
    `${defaultUrl}/invoices/${cleanId}`,
    getHeader()
  );
  return response.data;
}

export async function searchStudentsServerSide(
  q: string = "",
  page: number = 1,
  per_page: number = 10
) {
  const params = new URLSearchParams();
  if (q.trim()) params.append("q", q.trim());
  params.append("page", String(page));
  params.append("per_page", String(per_page));

  const response = await axios.get(
    `${defaultUrl}/students?${params.toString()}`,
    getHeader()
  );
  const data = response.data;
  const rawArray = Array.isArray(data)
    ? data
    : Array.isArray(data?.data?.data)
      ? data.data.data
      : Array.isArray(data?.data)
        ? data.data
        : [];

  return rawArray.map((st: any) => {
    const fullName = [st.firstname, st.surname, st.othername]
      .filter(Boolean)
      .join(" ");
    return {
      id: st.id,
      name: fullName || st.name || `Student #${st.id.substring(0, 6)}`,
      email: st.email,
      classroom: st.classroom
        ? { id: st.classroom.id, name: st.classroom.name }
        : undefined,
    };
  });
}

/* ==========================================
   PAYMENT VERIFICATION & APPROVAL SERVICES
   ========================================== */

export interface VerificationStudent {
  id: string;
  surname: string;
  firstname: string;
  othername?: string | null;
  email?: string;
  gender?: string;
  profile_picture?: string | null;
}

export interface PaymentVerificationItem {
  id: string;
  invoice_id: string;
  invoice_code?: string;
  student?: VerificationStudent;
  amount_paid: number;
  verified_amount?: number;
  proof_url: string;
  status: "pending" | "approved" | "rejected" | string;
  admin_notes?: string | null;
  rejection_reason?: string | null;
  approved_at?: string | null;
  rejected_at?: string | null;
  school_name?: string;
  school_signature?: string | null;
  created_at?: string;
  updated_at?: string;
  invoice?: InvoiceItem;
}

export interface ApprovePaymentPayload {
  verified_amount: number;
  admin_notes?: string;
}

export interface PaymentVerificationParams {
  status?: string;
  academic_session?: string;
  term?: string;
  page?: number;
  per_page?: number;
  q?: string;
}

export async function getPaymentVerifications(params?: PaymentVerificationParams | string) {
  const queryParams = new URLSearchParams();

  if (typeof params === "string") {
    if (params) queryParams.append("status", params);
  } else if (params) {
    if (params.status) queryParams.append("status", params.status);
    if (params.academic_session) queryParams.append("academic_session", params.academic_session);
    if (params.term) queryParams.append("term", params.term);
    if (params.q) queryParams.append("q", params.q);
    if (params.page) queryParams.append("page", String(params.page));
    if (params.per_page) queryParams.append("per_page", String(params.per_page));
  }

  const query = queryParams.toString() ? `?${queryParams.toString()}` : "";
  const response = await axios.get(
    `${defaultUrl}/payments/verification${query}`,
    getHeader()
  );
  return response.data;
}

export async function approvePaymentVerification({
  id,
  payload,
}: {
  id: string;
  payload: ApprovePaymentPayload;
}) {
  const response = await makePostRequest(
    `${defaultUrl}/payments/verification/${id}/approve`,
    payload
  );
  return response;
}

export interface RejectPaymentPayload {
  reason: string;
}

export async function rejectPaymentVerification({
  id,
  payload,
}: {
  id: string;
  payload: RejectPaymentPayload;
}) {
  const response = await makePostRequest(
    `${defaultUrl}/payments/verification/${id}/reject`,
    payload
  );
  return response;
}

export interface PostPaymentOnBehalfPayload {
  invoice_id: string;
  parent_id: string;
  amount_paid: number;
  payment_method: string;
  proof_url?: string;
  admin_notes?: string;
  transaction_pin: string;
}

export async function postPaymentOnBehalf(payload: PostPaymentOnBehalfPayload) {
  const response = await makePostRequest(
    `${defaultUrl}/payments/verification/on-behalf`,
    payload
  );
  return response;
}

export interface SetTransactionPinPayload {
  current_password: string;
  transaction_pin: string;
  transaction_pin_confirmation: string;
}

export async function setTransactionPin(payload: SetTransactionPinPayload) {
  const response = await makePostRequest(
    `${defaultUrl}/invoices/transaction-pin`,
    payload
  );
  return response;
}

// ---------------------------------------------------------------------------
// Expense Catalog Services
// ---------------------------------------------------------------------------

export interface ExpenseCatalogItemApi {
  id: string;
  code: string;
  name: string;
  description: string;
  icon_type: string;
  is_active: boolean;
  total_logged_outflow?: number;
  transactions_count?: number;
}

export interface ExpenseCatalogApiResponse {
  success: boolean;
  status_code: number;
  message: string;
  data: ExpenseCatalogItemApi[];
}

export interface CreateExpenseCatalogPayload {
  name: string;
  description: string;
  icon_type?: string;
}

export interface UpdateExpenseCatalogPayload {
  name: string;
  description: string;
  icon_type?: string;
}

export async function getExpenseCatalog(params?: { search?: string }): Promise<ExpenseCatalogApiResponse> {
  const q = new URLSearchParams();
  if (params?.search) q.append("search", params.search);
  const query = q.toString() ? `?${q.toString()}` : "";
  const response = await axios.get(`${defaultUrl}/expenses/catalog${query}`, getHeader());
  return response.data;
}

export async function createExpenseCatalog(payload: CreateExpenseCatalogPayload) {
  const response = await makePostRequest(
    `${defaultUrl}/expenses/catalog`,
    payload
  );
  return response;
}

export async function updateExpenseCatalog({
  id,
  payload,
}: {
  id: string;
  payload: UpdateExpenseCatalogPayload;
}) {
  const response = await makePutRequest(
    `${defaultUrl}/expenses/catalog/${id}`,
    payload
  );
  return response;
}

export async function deleteExpenseCatalog(id: string) {
  const response = await makeDeleteRequest(
    `${defaultUrl}/expenses/catalog/${id}`
  );
  return response;
}

// ---------------------------------------------------------------------------
// Expense Vendor Services
// ---------------------------------------------------------------------------

export interface ExpenseVendorItemApi {
  id: string;
  name: string;
  category_tag: string;
  contact_person: string;
  phone: string;
  bank_name: string;
  account_number: string;
  address: string;
  notes: string;
  total_outflows_paid?: number;
  transactions_count?: number;
}

export interface ExpenseVendorApiResponse {
  status_code: number;
  message: string;
  data: ExpenseVendorItemApi[];
}

export interface CreateExpenseVendorPayload {
  name: string;
  category_tag: string;
  contact_person?: string;
  phone?: string;
  bank_name?: string;
  account_number?: string;
  address?: string;
  notes?: string;
}

export interface UpdateExpenseVendorPayload {
  name: string;
  category_tag: string;
  contact_person?: string;
  phone?: string;
  bank_name?: string;
  account_number?: string;
  address?: string;
  notes?: string;
}

export async function getExpenseVendors(params?: { search?: string }): Promise<ExpenseVendorApiResponse> {
  const q = new URLSearchParams();
  if (params?.search) q.append("search", params.search);
  const query = q.toString() ? `?${q.toString()}` : "";
  const response = await axios.get(`${defaultUrl}/expenses/vendors${query}`, getHeader());
  return response.data;
}

export async function createExpenseVendor(payload: CreateExpenseVendorPayload) {
  const response = await makePostRequest(
    `${defaultUrl}/expenses/vendors`,
    payload
  );
  return response;
}

export async function updateExpenseVendor({
  id,
  payload,
}: {
  id: string;
  payload: UpdateExpenseVendorPayload;
}) {
  const response = await makePutRequest(
    `${defaultUrl}/expenses/vendors/${id}`,
    payload
  );
  return response;
}

export async function deleteExpenseVendor(id: string) {
  const response = await makeDeleteRequest(
    `${defaultUrl}/expenses/vendors/${id}`
  );
  return response;
}

// ---------------------------------------------------------------------------
// Expense Ledger Services
// ---------------------------------------------------------------------------

export interface ExpenseLedgerParams {
  date_filter_mode?: "month" | "single" | "range" | "all";
  month?: string;
  year?: string;
  specific_date?: string;
  from_date?: string;
  to_date?: string;
  catalog_id?: string;
  vendor?: string;
  search?: string;
}

export interface ExpenseLedgerItem {
  id: string;
  catalog_id: string;
  category_name: string;
  vendor_id?: string;
  paid_to: string;
  amount: number;
  expense_date: string;
  payment_method: "transfer" | "cash" | "pos" | "cheque";
  description: string;
  recorded_by: string;
  status: "verified" | "pending";
}

export interface ExpenseLedgerApiResponse {
  success: boolean;
  status_code: number;
  message: string;
  meta: { total_records: number; total_filtered_amount: number };
  data: ExpenseLedgerItem[];
}

export interface CreateExpensePayload {
  catalog_id: string;
  vendor_id: string;
  amount: number;
  expense_date: string;
  payment_method: "transfer" | "cash" | "pos" | "cheque";
  description?: string;
}

export async function getExpenses(params?: ExpenseLedgerParams): Promise<ExpenseLedgerApiResponse> {
  const q = new URLSearchParams();
  if (params?.date_filter_mode) q.append("date_filter_mode", params.date_filter_mode);
  if (params?.month) q.append("month", params.month);
  if (params?.year) q.append("year", params.year);
  if (params?.specific_date) q.append("specific_date", params.specific_date);
  if (params?.from_date) q.append("from_date", params.from_date);
  if (params?.to_date) q.append("to_date", params.to_date);
  if (params?.catalog_id && params.catalog_id !== "all") q.append("catalog_id", params.catalog_id);
  if (params?.vendor && params.vendor !== "all") q.append("vendor", params.vendor);
  if (params?.search) q.append("search", params.search);
  const query = q.toString() ? `?${q.toString()}` : "";
  const response = await axios.get(`${defaultUrl}/expenses${query}`, getHeader());
  return response.data;
}

export async function createExpense(payload: CreateExpensePayload) {
  return await makePostRequest(`${defaultUrl}/expenses`, payload);
}

export async function deleteExpense(id: string) {
  return await makeDeleteRequest(`${defaultUrl}/expenses/${id}`);
}

// ---------------------------------------------------------------------------
// Expense Analytics Services
// ---------------------------------------------------------------------------

export interface ExpenseAnalyticsParams extends ExpenseLedgerParams {}

export interface ExpenseAnalyticsResponse {
  success: boolean;
  status_code: number;
  message: string;
  data: {
    filter_context: any;
    metrics: {
      total_filtered_outflow: number;
      total_transactions_count: number;
      todays_outflow: number;
      todays_transactions_count: number;
      highest_spend_category: {
        catalog_id: string;
        name: string;
        category_code: string;
        icon_type: string;
        total_amount: number;
        transactions_count: number;
        percentage_share: number;
        description: string;
      } | null;
    };
    category_breakdown: {
      rank: number;
      catalog_id: string;
      name: string;
      code: string;
      icon_type: string;
      total_amount: number;
      transactions_count: number;
      percentage_share: number;
      average_per_transaction: number;
    }[];
    payment_channel_distribution: Record<string, {
      channel_name: string;
      total_amount: number;
      transactions_count: number;
      percentage_share: number;
    }>;
    daily_trend_timeline: { date: string; total_amount: number; transactions_count: number }[];
  };
}

export async function getExpenseAnalytics(params?: ExpenseAnalyticsParams): Promise<ExpenseAnalyticsResponse> {
  const q = new URLSearchParams();
  if (params?.date_filter_mode) q.append("date_filter_mode", params.date_filter_mode);
  if (params?.month) q.append("month", params.month);
  if (params?.year) q.append("year", params.year);
  if (params?.specific_date) q.append("specific_date", params.specific_date);
  if (params?.from_date) q.append("from_date", params.from_date);
  if (params?.to_date) q.append("to_date", params.to_date);
  if (params?.catalog_id && params.catalog_id !== "all") q.append("catalog_id", params.catalog_id);
  if (params?.vendor && params.vendor !== "all") q.append("vendor", params.vendor);
  const query = q.toString() ? `?${q.toString()}` : "";
  const response = await axios.get(`${defaultUrl}/expenses/analytics/summary${query}`, getHeader());
  return response.data;
}

// ---------------------------------------------------------------------------
// Expense CSV Export Services
// ---------------------------------------------------------------------------

async function downloadExpenseCsv(url: string, filename: string) {
  const response = await axios.get(url, { ...getHeader(), responseType: "blob" });
  const blob = new Blob([response.data], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(link.href);
}

export async function exportExpenseLedger(params?: ExpenseLedgerParams) {
  const q = new URLSearchParams();
  if (params?.date_filter_mode) q.append("date_filter_mode", params.date_filter_mode);
  if (params?.month) q.append("month", params.month);
  if (params?.year) q.append("year", params.year);
  if (params?.specific_date) q.append("specific_date", params.specific_date);
  if (params?.from_date) q.append("from_date", params.from_date);
  if (params?.to_date) q.append("to_date", params.to_date);
  if (params?.catalog_id && params.catalog_id !== "all") q.append("catalog_id", params.catalog_id);
  if (params?.vendor && params.vendor !== "all") q.append("vendor", params.vendor);
  if (params?.search) q.append("search", params.search);
  const query = q.toString() ? `?${q.toString()}` : "";
  const dateStamp = new Date().toISOString().split("T")[0];
  await downloadExpenseCsv(`${defaultUrl}/expenses/export/ledger${query}`, `School_Expense_Ledger_${dateStamp}.csv`);
}

export async function exportExpenseAnalytics(params?: ExpenseAnalyticsParams) {
  const q = new URLSearchParams();
  if (params?.date_filter_mode) q.append("date_filter_mode", params.date_filter_mode);
  if (params?.month) q.append("month", params.month);
  if (params?.year) q.append("year", params.year);
  if (params?.catalog_id && params.catalog_id !== "all") q.append("catalog_id", params.catalog_id);
  const query = q.toString() ? `?${q.toString()}` : "";
  const dateStamp = new Date().toISOString().split("T")[0];
  await downloadExpenseCsv(`${defaultUrl}/expenses/export/analytics${query}`, `Expense_Spend_Breakdown_${dateStamp}.csv`);
}

export async function exportExpenseVendors() {
  const dateStamp = new Date().toISOString().split("T")[0];
  await downloadExpenseCsv(`${defaultUrl}/expenses/export/vendors`, `School_Vendors_Directory_${dateStamp}.csv`);
}
